/* eslint-disable prefer-destructuring */
import React, { useEffect, useState } from "react";
import { I18nextProvider } from "react-i18next";
import { useFlags, withLDProvider } from "launchdarkly-react-client-sdk";

import MyFlights from "./containers/MyFlights/index";
import i18next from "./i18n";
import { loadGolPremiumFlag } from "./utils/cabinNomenclature";

let LDUser = window.location.origin;

export const getLDRelayURL = (hostname: string) => {
  let env = "";
  const smilesDomain = hostname.indexOf("smiles.com.br") > -1;
  const rx = smilesDomain ? /^(.*)\.smiles\.com\.br/g : /^(.*)\.voebiz\.com\.br/g;
  const res = rx.exec(hostname);
  if (res !== null) {
    if (res.length > 1 && res[1] && res[1].length > 3) {
      env = res[1];
    }
    env = env.replace(/portal|voebiz/g, "").replace("uat", "hml");
  }

  if (hostname === "localhost") {
    env = "-hml5";
    LDUser = "https://voebiz-uat5.smiles.com.br";
  }

  return `https://ldrelay${env}.smiles.com.br`;
};

interface AppProps {
  type: string | null;
}

const clientSideId = "62baf3989195871574e35e6c";
const launchDarklyURL = getLDRelayURL(window.location.hostname);

function App({ type }: AppProps) {
  const [loading, setLoading] = useState(true);
  const [flagReady, setFlagReady] = useState(false);
  const { apiDomain } = useFlags();

  useEffect(() => {
    if (apiDomain) {
      setLoading(false);
    }
  }, [apiDomain]);

  useEffect(() => {
    loadGolPremiumFlag().finally(() => {
      setFlagReady(true);
    });
  }, []);

  if (loading || !flagReady) {
    return <div />;
  }

  return (
    <I18nextProvider i18n={i18next}>
      <div className="vbz-lf" data-testid="app">
        <MyFlights type={type} />
      </div>
    </I18nextProvider>
  );
}

export default withLDProvider<AppProps>({
  clientSideID: clientSideId,
  user: { key: LDUser },
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
  options: {
    baseUrl: launchDarklyURL,
  },
})(App);
